import { useQuery, UseQueryOptions } from 'react-query';

import {Guid, AvailableNdas } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useAvailableNdasQuery (
	guid: Guid | undefined,
	roomUserGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<AvailableNdas, unknown, AvailableNdas, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.LenderNda.Available(guid, roomUserGuid),
		() =>
			AxiosUtils.getResponseData<AvailableNdas>(
				api.get(CerebroApiEndpoints.LenderNda.Available(guid, roomUserGuid))
			),
		options
	);
}
